module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('base-bar-chart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.printable || (!_vm.imgData && _vm.printable)),
      expression: "!printable || (!imgData && printable)"
    }],
    attrs: {
      "height": _vm.height ? _vm.height : null,
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    },
    on: {
      "chartCreated": _vm.setChart
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.printable && _vm.imgData),
      expression: "printable && imgData"
    }],
    attrs: {
      "height": _vm.height ? _vm.height : 200,
      "src": _vm.imgData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2523a91a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/charts/BarChart.vue
// module id = 3186
// module chunks = 3